// extracted by mini-css-extract-plugin
export default {"aspectRatioSelector":"_2ogGh___AspectRatioSelector-module__aspectRatioSelector"};